import { useApiQuery } from 'mf_core/query';

export function useGetNotificationHistory(
  readStatus: string = 'unread',
  toDate?: string
) {
  // Only add ToDate param if provided
  const toDateParam = toDate ? `&ToDate=${encodeURIComponent(toDate)}` : '';
  return useApiQuery<any>(
    `/account-management/v1/notifications/history?NotificationType=inapp&onlySummary=true&ReadStatus=${readStatus}${toDateParam}`
  );
}
